import { useSelector } from 'react-redux';
import { selectAllowedPaymentMethods } from '@homeplay/app';

export const usePaymentMethods = () => {
  const allowed = useSelector(selectAllowedPaymentMethods) || [];

  const has = (key) => allowed.includes(key);

  const mapping = {
    cashin: {
      acoinVoucher: has('ticket_cash_in'),
      acoinPhone: has('acoin_phone'),
      acoinCard: has('acoin'),
      acoinDirectDeposit: has('acoin_direct_deposit'),
      upiIntent: has('upi_intent_deposit'),
      upiQr: has('upi_qr_deposit'),
      octopaysP2c: has('octopays_deposit_p2c'),
    },
    cashout: {
      atm: has('im_withdrawal'),
      eft: has('eft_withdrawal'),
      upi: has('upi_withdrawal'),
      octopays: has('octopays_withdrawal'),
      ticket: has('ticket_cash_out'),
    },
    _isAllowed: (key) => has(key),
  };

  return mapping;
};


